<template>
  <div>

    <div ref="getHouseGroupByType" style="height:400px;"></div>


    <div ref="getHouseGroupByVolume" style="height:400px;"></div>


    <div ref="getHouseGroupByUse" style="height:400px;"></div>


  </div>
</template>

<script>
  export default {
    data() {
      return {
        apiPath: "/api/HouseData/",
        menus: [],
        modal_loading: false,
        loading: true,


        chartGetHouseGroupByType: null,
        chartGetHouseGroupByVolume: null,
        chartGetHouseGroupByUse: null,

      };
    },
    components: {},
    created: function() {

    },
    mounted: function() {

      this.GetHouseGroupByType();
      this.GetHouseGroupByVolume();
      this.GetHouseGroupByUse();


      window.onresize = function () {
        this.chartGetHouseGroupByType.resize();
        this.chartGetHouseGroupByVolume.resize();
        this.chartGetHouseGroupByUse.resize();
      };

    },
    methods: {

      //每类场馆类别
      async GetHouseGroupByType () {


        // 基于准备好的dom，初始化echarts实例
        this.chartGetHouseGroupByType = this.echarts.init(this.$refs.getHouseGroupByType);
        // 指定图表的配置项和数据
        let option = {
          title: {
            text: '每类场馆数量',
            subtext: '',
            x: 'center'
          },
          tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          legend: {
            show: false,
            formatter: (name)=> {
              return this.echarts.format.truncateText(name, 80, '14px Microsoft Yahei', '…');
            },
            left: 'left',
            type: 'scroll',
          },
          series: [
            {
              name: '场馆类别',
              type: 'pie',
              radius: '55%',
              center: ['50%', '60%'],
              data: [
                //{ value: 335, name: '直接访问' },
                //{ value: 310, name: '邮件营销' },
                //{ value: 234, name: '联盟广告' },
                //{ value: 135, name: '视频广告' },
                //{ value: 1548, name: '搜索引擎' }
              ],
              //itemStyle: {
              //    emphasis: {
              //        shadowBlur: 10,
              //        shadowOffsetX: 0,
              //        shadowColor: 'rgba(0, 0, 0, 0.5)'
              //    }
              //}
            }
          ]
        };

        // 使用刚指定的配置项和数据显示图表。
        this.chartGetHouseGroupByType.setOption(option);
        this.chartGetHouseGroupByType.showLoading();

        let res = await this.xyapi.get(
          this.$store.state.apiPath + this.apiPath + 'GetHouseGroupByType'
        );
        if (res.success) {
          let list = [];

          if(res.data!==null){
            Object.keys(res.data).forEach(function(key){
              list.push({ value: res.data[key], name: key });
            });
          }
          option.series[0].data = list;
          this.chartGetHouseGroupByType.hideLoading();
          this.chartGetHouseGroupByType.setOption(option, true);

        } else {
          this.xy.msgError(res.msg);
          // MainVue.$Modal.error({ title: "错误信息", content: res.data.msg });
        }

      },


      //场馆容纳人数分布--柱状图
      async GetHouseGroupByVolume () {

        // 基于准备好的dom，初始化echarts实例
        this.chartGetHouseGroupByVolume = this.echarts.init(this.$refs.getHouseGroupByVolume);
        // 指定图表的配置项和数据

        let option = {
          title: {
            text: '场馆容纳人数分布',
            subtext: '',
            x: 'center'
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: [],
              axisTick: {
                alignWithLabel: true
              }
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: [
            {
              name: '场馆数量',
              type: 'bar',
              barWidth: '60%',
              data: []
            }
          ]
        };
        // 使用刚指定的配置项和数据显示图表。
        this.chartGetHouseGroupByVolume.setOption(option);
        this.chartGetHouseGroupByVolume.showLoading();


        let res = await this.xyapi.get(
          this.$store.state.apiPath + this.apiPath + 'GetHouseGroupByVolume'
        );
        if (res.success) {
          let xAxisDataList = [];
          let seriesDataList = [];
          if(res.data!==null){
            Object.keys(res.data).forEach(function(key){
              xAxisDataList.push(key);
              seriesDataList.push(res.data[key]);
            });
          }
          option.xAxis[0].data = xAxisDataList;
          option.series[0].data = seriesDataList;

          this.chartGetHouseGroupByVolume.hideLoading();
          this.chartGetHouseGroupByVolume.setOption(option, true);

        } else {
          this.xy.msgError(res.msg);
          // MainVue.$Modal.error({ title: "错误信息", content: res.data.msg });
        }

      },


      //上课场馆/非上课场馆--饼状图
      async GetHouseGroupByUse () {

        // 基于准备好的dom，初始化echarts实例
        this.chartGetHouseGroupByUse = this.echarts.init(this.$refs.getHouseGroupByUse);
        // 指定图表的配置项和数据
        let option = {
          title: {
            text: '上课场馆/非上课场馆\n',
            subtext: '',
            x: 'center',
          },
          tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          legend: {
            formatter: (name) =>{
              return this.echarts.format.truncateText(name, 80, '14px Microsoft Yahei', '…');
            },
            left: 'left',
            type: 'scroll',
            top:"6%",
          },
          series: [
            {
              name: '上课场馆/非上课场馆',
              type: 'pie',
              radius: '55%',
              center: ['50%', '60%'],
              data: [],
              //itemStyle: {
              //    emphasis: {
              //        shadowBlur: 10,
              //        shadowOffsetX: 0,
              //        shadowColor: 'rgba(0, 0, 0, 0.5)'
              //    }
              //}
            }
          ]
        };


        // 使用刚指定的配置项和数据显示图表。
        this.chartGetHouseGroupByUse.setOption(option);
        this.chartGetHouseGroupByUse.showLoading();

        let res = await this.xyapi.get(
          this.$store.state.apiPath + this.apiPath + 'GetHouseGroupByUse'
        );
        if (res.success) {

          let list = [];

          if(res.data!==null){
            Object.keys(res.data).forEach(function(key){
              list.push({ value: res.data[key], name: key });
            });
          }
          option.series[0].data = list;

          this.chartGetHouseGroupByUse.hideLoading();
          this.chartGetHouseGroupByUse.setOption(option, true);
        } else {
          this.xy.msgError(res.msg);
          // MainVue.$Modal.error({ title: "错误信息", content: res.data.msg });
        }


      },
    }
  };
</script>
<style lang='less' >

</style>

